// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__xkD3x"};